export default () => {
    return {
        cupones: [],
        usosLimite: [
            { text: 'General', value: 'general' },
            { text: 'Usuario', value: 'usuario' },
        ],
        tiposCupones: [
            { text: 'Descuento porcentaje', value: 'descuento_porcentaje' },
            { text: 'Descuento absoluto', value: 'descuento_absoluto' },
            { text: 'Producto gratis', value: 'producto' },
            { text: 'Categoría gratis', value: 'categoria' },
        ]
    }
}